import React from 'react';
import NewEditableGrid from '../../../shared/NewEditableGrid';
import { EditOutlined, SearchOutlined} from '@ant-design/icons';
import { getTicketInfo, searchTickets } from '../../../../networking/NetworkingTicket';
import TicketSearchForm from './TicketSearchForm';
import { formatDate } from '../../../../helpers/FormatHelper';
import { getStyle } from '../../../../styles/styles';
import { Print } from '../../../tools/print/PrintLabel';
var style = getStyle();

export default class TicketSearchScreen extends React.Component {
    
    state = {
        tickets: [],
        columnDetail: {},
        valueDateFrom: '',
        valueDateTo: ''
    }
    componentDidMount() {        
        if(this.props.ticketType!==undefined && this.props.ticketType!==null){

            let valueDateTo = formatDate(new Date());
            let valueDateFrom1 = new Date();
            valueDateFrom1.setDate(valueDateFrom1.getDate() - 5);
            let valueDateFrom = formatDate(valueDateFrom1);

            var objFilter = {
                TicketDateFrom: valueDateFrom,
                TicketDateTo: valueDateTo,
                TicketType: this.props.ticketType
            };
            this.setState({ valueDateFrom: valueDateFrom, valueDateTo: valueDateTo });
            this.searchDealsGrid(objFilter);
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.ticketType !== this.props.ticketType) {
            var objFilter = {
                ticketType: this.props.ticketType
            };
            this.searchDealsGrid(objFilter);
            this.clearGrid();
        }
    } 
    
    clearGrid() {
        this.setState({ tickets: [], columnDetail: {} });
    }

    searchDealsGrid(obj) {
        if(this.props.ticketType!==undefined && this.props.ticketType!==null){
            obj={ ...obj, ticketType: this.props.ticketType };
        }
        searchTickets(obj).then(
            (json) => {
                if(Number(json.httpStatusCode) === 200){
                    let columnDetail = JSON.parse(json.columnDetail);
                    let totalCount = json.totalCount;
                    let tickets = json.tickets;                    
                    this.setState({tickets: tickets, columnDetail: columnDetail});
                }
                else {
                    /*var alertMessage;
                    if(json.Message !== undefined){
                        alertMessage = json.Message;
                    }
                    else{
                        alertMessage = 'Search failed. Please try again or contact the administrator';
                    }
                    this.setState({alertMessage: alertMessage,
                        alertTitle: 'Error',
                        showAlert: true,
                    });*/
                }            
            }
        );
    }

    handleRowClick=async(obj)=>{
        if(this.props.onTicketSelected)
        {
            const responseTicket = await getTicketInfo(obj.TicketNo);
            if(responseTicket)
            {
                this.props.onTicketSelected(responseTicket);
            }
        }
    }

    PrinterClick=async(obj)=>{
        if(this.props.onticketSelected)
        {
            Print(obj.TicketNo);
        }
    }
        
    render() {
        return (
            <div>
                               
                <TicketSearchForm ticketType={this.props.ticketType} valueDateTo={this.state.valueDateTo} valueDateFrom={this.state.valueDateFrom} searchDealsGrid={this.searchDealsGrid.bind(this)} clearGrid={this.clearGrid.bind(this)}/>
                <hr/>
                <div style={{ visibility: this.state.isVisible }}>
                    <NewEditableGrid
                        data={this.state.tickets}
                        columnDetails={this.state.columnDetail}
                        isEditable={false}         
                        useIcons={true}
                        usePrintLabel={true}
                        dynamicActions={[
                            {name: 'View', function: this.handleRowClick, isIcon: true, icon: <SearchOutlined /> }
                            //{name: 'Print', function: this.PrinterClick, isIcon: true, icon: <PrinterOutlined /> }
                            ]} />
                        
                </div>
            </div>
        );
    }

}